import { ActionTypes } from './constants';

export const initialState = Object.freeze({});
export const reducer = (state = initialState, action = {}) => {
    if (action.type === ActionTypes.SET_THEME) {
        return { ...action.payload };
    }

    return state;
};
